/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedDashboardRouteImport } from './routes/_authed/dashboard'
import { Route as AuthedCustomersIndexRouteImport } from './routes/_authed/customers/index'
import { Route as AuthedCustomersCustomerIdRouteImport } from './routes/_authed/customers/$customerId'
import { Route as AuthedEmployeesIndexRouteImport } from './routes/_authed/employees/index'
import { Route as AuthedEmployeesNewRouteImport } from './routes/_authed/employees/new'
import { Route as AuthedLeadsIndexRouteImport } from './routes/_authed/leads/index'
import { Route as AuthedLeadsLeadIdRouteImport } from './routes/_authed/leads/$leadId'
import { Route as AuthedLeadsColdRouteImport } from './routes/_authed/leads/cold'
import { Route as AuthedLeadsNewRouteImport } from './routes/_authed/leads/new'
import { Route as AuthedOrdersIndexRouteImport } from './routes/_authed/orders/index'
import { Route as AuthedOrdersOrderIdRouteImport } from './routes/_authed/orders/$orderId'
import { Route as AuthedQuotesIndexRouteImport } from './routes/_authed/quotes/index'
import { Route as AuthedQuotesQuoteIdRouteImport } from './routes/_authed/quotes/$quoteId'
import { Route as AuthedTeamPerformanceIndexRouteImport } from './routes/_authed/team-performance/index'
import { Route as AuthedTeamsIndexRouteImport } from './routes/_authed/teams/index'
import { Route as AuthedTeamsNewRouteImport } from './routes/_authed/teams/new'
import { Route as AuthedEmployeesEmployeeIdEditRouteImport } from './routes/_authed/employees/$employeeId/edit'
import { Route as AuthedLeadsLeadIdEditRouteImport } from './routes/_authed/leads/$leadId_.edit'
import { Route as AuthedTeamsTeamIdIndexRouteImport } from './routes/_authed/teams/$teamId/index'
import { Route as AuthedTeamsTeamIdEditRouteImport } from './routes/_authed/teams/$teamId/edit'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCustomersIndexRoute = AuthedCustomersIndexRouteImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCustomersCustomerIdRoute =
  AuthedCustomersCustomerIdRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedEmployeesIndexRoute = AuthedEmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEmployeesNewRoute = AuthedEmployeesNewRouteImport.update({
  id: '/employees/new',
  path: '/employees/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsIndexRoute = AuthedLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsLeadIdRoute = AuthedLeadsLeadIdRouteImport.update({
  id: '/leads/$leadId',
  path: '/leads/$leadId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsColdRoute = AuthedLeadsColdRouteImport.update({
  id: '/leads/cold',
  path: '/leads/cold',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedLeadsNewRoute = AuthedLeadsNewRouteImport.update({
  id: '/leads/new',
  path: '/leads/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrdersIndexRoute = AuthedOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrdersOrderIdRoute = AuthedOrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQuotesIndexRoute = AuthedQuotesIndexRouteImport.update({
  id: '/quotes/',
  path: '/quotes/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedQuotesQuoteIdRoute = AuthedQuotesQuoteIdRouteImport.update({
  id: '/quotes/$quoteId',
  path: '/quotes/$quoteId',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamPerformanceIndexRoute =
  AuthedTeamPerformanceIndexRouteImport.update({
    id: '/team-performance/',
    path: '/team-performance/',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedTeamsIndexRoute = AuthedTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamsNewRoute = AuthedTeamsNewRouteImport.update({
  id: '/teams/new',
  path: '/teams/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedEmployeesEmployeeIdEditRoute =
  AuthedEmployeesEmployeeIdEditRouteImport.update({
    id: '/employees/$employeeId/edit',
    path: '/employees/$employeeId/edit',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedLeadsLeadIdEditRoute = AuthedLeadsLeadIdEditRouteImport.update({
  id: '/leads/$leadId_/edit',
  path: '/leads/$leadId/edit',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamsTeamIdIndexRoute = AuthedTeamsTeamIdIndexRouteImport.update({
  id: '/teams/$teamId/',
  path: '/teams/$teamId/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedTeamsTeamIdEditRoute = AuthedTeamsTeamIdEditRouteImport.update({
  id: '/teams/$teamId/edit',
  path: '/teams/$teamId/edit',
  getParentRoute: () => AuthedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdRoute
  '/employees/new': typeof AuthedEmployeesNewRoute
  '/leads/$leadId': typeof AuthedLeadsLeadIdRoute
  '/leads/cold': typeof AuthedLeadsColdRoute
  '/leads/new': typeof AuthedLeadsNewRoute
  '/orders/$orderId': typeof AuthedOrdersOrderIdRoute
  '/quotes/$quoteId': typeof AuthedQuotesQuoteIdRoute
  '/teams/new': typeof AuthedTeamsNewRoute
  '/customers/': typeof AuthedCustomersIndexRoute
  '/employees/': typeof AuthedEmployeesIndexRoute
  '/leads/': typeof AuthedLeadsIndexRoute
  '/orders/': typeof AuthedOrdersIndexRoute
  '/quotes/': typeof AuthedQuotesIndexRoute
  '/team-performance/': typeof AuthedTeamPerformanceIndexRoute
  '/teams/': typeof AuthedTeamsIndexRoute
  '/employees/$employeeId/edit': typeof AuthedEmployeesEmployeeIdEditRoute
  '/leads/$leadId/edit': typeof AuthedLeadsLeadIdEditRoute
  '/teams/$teamId/edit': typeof AuthedTeamsTeamIdEditRoute
  '/teams/$teamId/': typeof AuthedTeamsTeamIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthedDashboardRoute
  '/customers/$customerId': typeof AuthedCustomersCustomerIdRoute
  '/employees/new': typeof AuthedEmployeesNewRoute
  '/leads/$leadId': typeof AuthedLeadsLeadIdRoute
  '/leads/cold': typeof AuthedLeadsColdRoute
  '/leads/new': typeof AuthedLeadsNewRoute
  '/orders/$orderId': typeof AuthedOrdersOrderIdRoute
  '/quotes/$quoteId': typeof AuthedQuotesQuoteIdRoute
  '/teams/new': typeof AuthedTeamsNewRoute
  '/customers': typeof AuthedCustomersIndexRoute
  '/employees': typeof AuthedEmployeesIndexRoute
  '/leads': typeof AuthedLeadsIndexRoute
  '/orders': typeof AuthedOrdersIndexRoute
  '/quotes': typeof AuthedQuotesIndexRoute
  '/team-performance': typeof AuthedTeamPerformanceIndexRoute
  '/teams': typeof AuthedTeamsIndexRoute
  '/employees/$employeeId/edit': typeof AuthedEmployeesEmployeeIdEditRoute
  '/leads/$leadId/edit': typeof AuthedLeadsLeadIdEditRoute
  '/teams/$teamId/edit': typeof AuthedTeamsTeamIdEditRoute
  '/teams/$teamId': typeof AuthedTeamsTeamIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/customers/$customerId': typeof AuthedCustomersCustomerIdRoute
  '/_authed/employees/new': typeof AuthedEmployeesNewRoute
  '/_authed/leads/$leadId': typeof AuthedLeadsLeadIdRoute
  '/_authed/leads/cold': typeof AuthedLeadsColdRoute
  '/_authed/leads/new': typeof AuthedLeadsNewRoute
  '/_authed/orders/$orderId': typeof AuthedOrdersOrderIdRoute
  '/_authed/quotes/$quoteId': typeof AuthedQuotesQuoteIdRoute
  '/_authed/teams/new': typeof AuthedTeamsNewRoute
  '/_authed/customers/': typeof AuthedCustomersIndexRoute
  '/_authed/employees/': typeof AuthedEmployeesIndexRoute
  '/_authed/leads/': typeof AuthedLeadsIndexRoute
  '/_authed/orders/': typeof AuthedOrdersIndexRoute
  '/_authed/quotes/': typeof AuthedQuotesIndexRoute
  '/_authed/team-performance/': typeof AuthedTeamPerformanceIndexRoute
  '/_authed/teams/': typeof AuthedTeamsIndexRoute
  '/_authed/employees/$employeeId/edit': typeof AuthedEmployeesEmployeeIdEditRoute
  '/_authed/leads/$leadId_/edit': typeof AuthedLeadsLeadIdEditRoute
  '/_authed/teams/$teamId/edit': typeof AuthedTeamsTeamIdEditRoute
  '/_authed/teams/$teamId/': typeof AuthedTeamsTeamIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/customers/$customerId'
    | '/employees/new'
    | '/leads/$leadId'
    | '/leads/cold'
    | '/leads/new'
    | '/orders/$orderId'
    | '/quotes/$quoteId'
    | '/teams/new'
    | '/customers/'
    | '/employees/'
    | '/leads/'
    | '/orders/'
    | '/quotes/'
    | '/team-performance/'
    | '/teams/'
    | '/employees/$employeeId/edit'
    | '/leads/$leadId/edit'
    | '/teams/$teamId/edit'
    | '/teams/$teamId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/customers/$customerId'
    | '/employees/new'
    | '/leads/$leadId'
    | '/leads/cold'
    | '/leads/new'
    | '/orders/$orderId'
    | '/quotes/$quoteId'
    | '/teams/new'
    | '/customers'
    | '/employees'
    | '/leads'
    | '/orders'
    | '/quotes'
    | '/team-performance'
    | '/teams'
    | '/employees/$employeeId/edit'
    | '/leads/$leadId/edit'
    | '/teams/$teamId/edit'
    | '/teams/$teamId'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/_authed/dashboard'
    | '/_authed/customers/$customerId'
    | '/_authed/employees/new'
    | '/_authed/leads/$leadId'
    | '/_authed/leads/cold'
    | '/_authed/leads/new'
    | '/_authed/orders/$orderId'
    | '/_authed/quotes/$quoteId'
    | '/_authed/teams/new'
    | '/_authed/customers/'
    | '/_authed/employees/'
    | '/_authed/leads/'
    | '/_authed/orders/'
    | '/_authed/quotes/'
    | '/_authed/team-performance/'
    | '/_authed/teams/'
    | '/_authed/employees/$employeeId/edit'
    | '/_authed/leads/$leadId_/edit'
    | '/_authed/teams/$teamId/edit'
    | '/_authed/teams/$teamId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/': {
      id: '/_authed/customers/'
      path: '/customers'
      fullPath: '/customers/'
      preLoaderRoute: typeof AuthedCustomersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/customers/$customerId': {
      id: '/_authed/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/customers/$customerId'
      preLoaderRoute: typeof AuthedCustomersCustomerIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/employees/': {
      id: '/_authed/employees/'
      path: '/employees'
      fullPath: '/employees/'
      preLoaderRoute: typeof AuthedEmployeesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/employees/new': {
      id: '/_authed/employees/new'
      path: '/employees/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof AuthedEmployeesNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads/': {
      id: '/_authed/leads/'
      path: '/leads'
      fullPath: '/leads/'
      preLoaderRoute: typeof AuthedLeadsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads/$leadId': {
      id: '/_authed/leads/$leadId'
      path: '/leads/$leadId'
      fullPath: '/leads/$leadId'
      preLoaderRoute: typeof AuthedLeadsLeadIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads/cold': {
      id: '/_authed/leads/cold'
      path: '/leads/cold'
      fullPath: '/leads/cold'
      preLoaderRoute: typeof AuthedLeadsColdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads/new': {
      id: '/_authed/leads/new'
      path: '/leads/new'
      fullPath: '/leads/new'
      preLoaderRoute: typeof AuthedLeadsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/orders/': {
      id: '/_authed/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthedOrdersIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/orders/$orderId': {
      id: '/_authed/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AuthedOrdersOrderIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/quotes/': {
      id: '/_authed/quotes/'
      path: '/quotes'
      fullPath: '/quotes/'
      preLoaderRoute: typeof AuthedQuotesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/quotes/$quoteId': {
      id: '/_authed/quotes/$quoteId'
      path: '/quotes/$quoteId'
      fullPath: '/quotes/$quoteId'
      preLoaderRoute: typeof AuthedQuotesQuoteIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/team-performance/': {
      id: '/_authed/team-performance/'
      path: '/team-performance'
      fullPath: '/team-performance/'
      preLoaderRoute: typeof AuthedTeamPerformanceIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/': {
      id: '/_authed/teams/'
      path: '/teams'
      fullPath: '/teams/'
      preLoaderRoute: typeof AuthedTeamsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/new': {
      id: '/_authed/teams/new'
      path: '/teams/new'
      fullPath: '/teams/new'
      preLoaderRoute: typeof AuthedTeamsNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/employees/$employeeId/edit': {
      id: '/_authed/employees/$employeeId/edit'
      path: '/employees/$employeeId/edit'
      fullPath: '/employees/$employeeId/edit'
      preLoaderRoute: typeof AuthedEmployeesEmployeeIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/leads/$leadId_/edit': {
      id: '/_authed/leads/$leadId_/edit'
      path: '/leads/$leadId/edit'
      fullPath: '/leads/$leadId/edit'
      preLoaderRoute: typeof AuthedLeadsLeadIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/': {
      id: '/_authed/teams/$teamId/'
      path: '/teams/$teamId'
      fullPath: '/teams/$teamId/'
      preLoaderRoute: typeof AuthedTeamsTeamIdIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/teams/$teamId/edit': {
      id: '/_authed/teams/$teamId/edit'
      path: '/teams/$teamId/edit'
      fullPath: '/teams/$teamId/edit'
      preLoaderRoute: typeof AuthedTeamsTeamIdEditRouteImport
      parentRoute: typeof AuthedRoute
    }
  }
}

interface AuthedRouteChildren {
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedCustomersCustomerIdRoute: typeof AuthedCustomersCustomerIdRoute
  AuthedEmployeesNewRoute: typeof AuthedEmployeesNewRoute
  AuthedLeadsLeadIdRoute: typeof AuthedLeadsLeadIdRoute
  AuthedLeadsColdRoute: typeof AuthedLeadsColdRoute
  AuthedLeadsNewRoute: typeof AuthedLeadsNewRoute
  AuthedOrdersOrderIdRoute: typeof AuthedOrdersOrderIdRoute
  AuthedQuotesQuoteIdRoute: typeof AuthedQuotesQuoteIdRoute
  AuthedTeamsNewRoute: typeof AuthedTeamsNewRoute
  AuthedCustomersIndexRoute: typeof AuthedCustomersIndexRoute
  AuthedEmployeesIndexRoute: typeof AuthedEmployeesIndexRoute
  AuthedLeadsIndexRoute: typeof AuthedLeadsIndexRoute
  AuthedOrdersIndexRoute: typeof AuthedOrdersIndexRoute
  AuthedQuotesIndexRoute: typeof AuthedQuotesIndexRoute
  AuthedTeamPerformanceIndexRoute: typeof AuthedTeamPerformanceIndexRoute
  AuthedTeamsIndexRoute: typeof AuthedTeamsIndexRoute
  AuthedEmployeesEmployeeIdEditRoute: typeof AuthedEmployeesEmployeeIdEditRoute
  AuthedLeadsLeadIdEditRoute: typeof AuthedLeadsLeadIdEditRoute
  AuthedTeamsTeamIdEditRoute: typeof AuthedTeamsTeamIdEditRoute
  AuthedTeamsTeamIdIndexRoute: typeof AuthedTeamsTeamIdIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedCustomersCustomerIdRoute: AuthedCustomersCustomerIdRoute,
  AuthedEmployeesNewRoute: AuthedEmployeesNewRoute,
  AuthedLeadsLeadIdRoute: AuthedLeadsLeadIdRoute,
  AuthedLeadsColdRoute: AuthedLeadsColdRoute,
  AuthedLeadsNewRoute: AuthedLeadsNewRoute,
  AuthedOrdersOrderIdRoute: AuthedOrdersOrderIdRoute,
  AuthedQuotesQuoteIdRoute: AuthedQuotesQuoteIdRoute,
  AuthedTeamsNewRoute: AuthedTeamsNewRoute,
  AuthedCustomersIndexRoute: AuthedCustomersIndexRoute,
  AuthedEmployeesIndexRoute: AuthedEmployeesIndexRoute,
  AuthedLeadsIndexRoute: AuthedLeadsIndexRoute,
  AuthedOrdersIndexRoute: AuthedOrdersIndexRoute,
  AuthedQuotesIndexRoute: AuthedQuotesIndexRoute,
  AuthedTeamPerformanceIndexRoute: AuthedTeamPerformanceIndexRoute,
  AuthedTeamsIndexRoute: AuthedTeamsIndexRoute,
  AuthedEmployeesEmployeeIdEditRoute: AuthedEmployeesEmployeeIdEditRoute,
  AuthedLeadsLeadIdEditRoute: AuthedLeadsLeadIdEditRoute,
  AuthedTeamsTeamIdEditRoute: AuthedTeamsTeamIdEditRoute,
  AuthedTeamsTeamIdIndexRoute: AuthedTeamsTeamIdIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
